/* eslint-disable */
/*
 * Product Tour JS
 * author: Francesco Rizzi
 * url: http://francescorizzi.info/projects/product-tour-js/
 * requires: jQuery
 * */
import $ from 'jquery';

window.ProductTourJS = {
  tips: false,
  options: false,
  currentTip: 0,
  totalSteps: 0,
  eventsSet: false,
  $mainWrapper: false,
  $darkenLayer: false,
  $current: false,
  semaphore: false,
  semaphoreResize: false,
  defaultsOptions: {
    darkLayerPersistence: false,
    next: 'Next',
    prev: 'Previous',
    finish: 'Okay!',
    mobileThreshold: 768,
  },

  init(options) {
    this.tips = options.tips;
    this.options = { ...this.defaultsOptions, ...options.options };

    if (this.baseCheckOptions()) {
      this.totalSteps = this.tips.length;
      $('.product-tour-js-cover-layer, .product-tour-js-single-step').remove();

      this.$mainWrapper = $('body');
      this.$darkenLayer = $('<div class="product-tour-js-cover-layer"></div>');
      this.$mainWrapper.append(this.$darkenLayer);
      this.htmlInit(this.$mainWrapper);
      this.bindEvents();

      return true;
    }
  },

  start() {
    if (this.baseCheckOptions() && this.totalSteps > 0) {
      this.setPositions();
      this.currentTip = 0;

      this.options.darkLayerPersistence && this.$darkenLayer.addClass('is-always-visible');
      this.darken();

      this.$current = $('.product-tour-js-single-step.js-product-tour-index-0').addClass(
        'is-selected',
      );
      this.$mainWrapper.addClass('product-tour-js-active');

      return true;
    }
  },

  baseCheckOptions() {
    const ok = this.tips && Array.isArray(this.tips) && typeof this.tips[0] === 'object';
    if (!ok) {
      throw new Error('product-tour-js: Invalid config options.');
    }
    return ok;
  },

  bindEvents() {
    if (!this.eventsSet) {
      const self = this;
      const $wrapper = $('html');

      const onNext = function () {
        return self.goNext();
      };

      const onPrev = function () {
        return self.goPrev();
      };

      const onClose = function () {
        return self.exit();
      };

      $wrapper.on('click', '.product-tour-js-prev', onPrev);
      $wrapper.on('click', '.product-tour-js-next', onNext);
      $wrapper.on('swiperight', onPrev);
      $wrapper.on('swipeleft', onNext);

      $wrapper.keyup((e) => {
        e.which == '37'
          ? onPrev()
          : e.which == '39'
          ? onNext()
          : e.which == '27'
          ? onClose()
          : null;
      });

      $wrapper.on('click', '.js-product-tour-js-tour-close', onClose);
      $wrapper.on('click', '.js-product-tour-js-tour-start', this.start.bind(this));
      $(window).on('resize', this.onResizeCallable.bind(this));

      this.eventsSet = true;
    }
  },

  navigationInit() {
    let html = `<div class="product-tour-js-nav"><span class="product-tour-js-nav-numeric"><b class="product-tour-js-actual-step">1</b> of ${this.totalSteps}</span><ul class="product-tour-js-tour-nav"><li><a href="#0" class="product-tour-js-prev">${this.options.prev}</li><li><a href="#0" class="product-tour-js-next">${this.options.next}</a></li></ul></div><a href="#0" class="product-tour-js-close js-product-tour-js-tour-close">Close</a>`;
    const self = this;

    $.each(this.tips, (tipIndex) => {
      const elem = $(`.product-tour-js-single-step.js-product-tour-index-${tipIndex}`);
      const nextIndex = tipIndex + 1;
      const nextClass = nextIndex < self.totalSteps ? '' : 'inactive';
      const prevClass = nextIndex === 1 ? 'inactive' : '';
      html =
        tipIndex + 1 === self.tips.length
          ? `${html}<div class="product-tour-js-single-step-final-btn js-product-tour-js-tour-close ">${self.options.finish}</div>`
          : html;
      const $html = $(html);

      $html.find('.product-tour-js-next').addClass(nextClass);
      $html.find('.product-tour-js-prev').addClass(prevClass);
      $html.find('.product-tour-js-actual-step').html(nextIndex);

      elem.find('.product-tour-js-single-step-inner').append($html);
    });
  },

  onSelected() {
    const self = this;
    const f = this.tips[this.currentTip].onSelected;
    typeof f === 'function' && f(self);
  },

  changeStep(direction) {
    if (this.isStarted()) {
      const nextStep = this.currentTip + (direction === 'next' ? 1 : -1);

      if (nextStep === this.totalSteps || nextStep === -1) {
        return false;
      }
      if (!this.checkAndLock()) {
        return false;
      }

      this.dispatch(`on-product-tour-js-${direction}`);

      this.$current.removeClass('is-selected');
      this.darken();
      this.$current = $(`.product-tour-js-single-step.js-product-tour-index-${nextStep}`).addClass(
        'is-selected',
      );
      this.currentTip = nextStep;
      this.onSelected();
    }
  },

  dispatch(name) {
    if (this.isStarted()) {
      const self = this;
      $(window).trigger(name, self);
    }
  },

  goNext() {
    this.changeStep('next');
  },

  goPrev() {
    this.changeStep('prev');
  },

  darken() {
    const self = this;
    this.$darkenLayer
      .addClass('is-visible')
      .on('webkitAnimationEnd msAnimationEnd animationend', () => {
        self.$darkenLayer.removeClass('is-visible');
      });
  },

  isStarted() {
    return !!this.$current;
  },

  exit() {
    this.dispatch('on-product-tour-js-exit');

    if (this.isStarted()) {
      this.$current.removeClass('is-selected');
    }
    this.$darkenLayer.removeClass('is-visible');
    this.$darkenLayer.removeClass('is-always-visible');
    this.$mainWrapper.removeClass('product-tour-js-active');
    this.$current = false;
  },

  isMobile() {
    return $(window).width() < this.options.mobileThreshold;
  },

  checkAndLock() {
    if (this.isMobile() || this.options.darkLayerPersistence) {
      return true;
    }

    const self = this;

    if (self.semaphore === false) {
      self.semaphore = true;
      setTimeout(() => {
        self.semaphore = false;
      }, 2500);
      return true;
    }
  },

  getRelativePosition(e, x, y, offX, offY) {
    return {
      x: e.offset().left + (e[0].offsetWidth / 100) * x + offX,
      y: e.offset().top + (e[0].offsetHeight / 100) * y + offY,
    };
  },

  onResizeCallable() {
    const self = this;

    if (!self.semaphoreResize && !self.isMobile()) {
      self.semaphoreResize = true;
      setTimeout(() => {
        self.setPositions();
        self.semaphoreResize = false;
      }, 300);
    }
  },

  setPositions() {
    const self = this;
    $.each(this.tips, (index, tip) => {
      self.setPosition(index, tip);
    });
  },

  setPosition(index, tip) {
    const elem = $(tip.selector).eq(0);
    const positions = this.getRelativePosition(elem, tip.x, tip.y, tip.offx, tip.offy);

    $(`.product-tour-js-single-step.js-product-tour-index-${index}`).css({
      top: `${positions.y}px`,
      left: `${positions.x}px`,
    });
  },

  htmlInit($wrapper) {
    let html = '';
    const self = this;

    $.each(this.tips, (index, tip) => {
      html += `<div class='product-tour-js-single-step js-product-tour-index-${index}'><span class='product-tour-js-pulse'></span><div class='product-tour-js-single-step-inner is-${
        tip.position
      }'><div class='product-tour-js-progress'><span class='product-tour-js-progress-inner' style='width: ${Math.round(
        ((index + 1) / self.totalSteps) * 100,
      )}%'></span></div><div class='product-tour-js-title'>${
        tip.title
      }</div><div class='product-tour-js-description'>${
        tip.description
      }</div><div class='product-tour-js-image' style='background-image: url(${tip.image})'></div>${
        tip.additionalHtml || ''
      }</div></div>`;
    });

    $wrapper.append(html);
    this.navigationInit();
  },
};
